(function () {
  function initVitaminaCFormLinks() {
    var root = document.querySelector('.vcv2');
    if (!root || root.dataset.formLinksReady === 'true') return Boolean(root);

    var forms = Array.prototype.filter.call(document.forms, function (form) {
      return form.action && form.action.indexOf('/cart/add') !== -1 && form.offsetWidth > 0 && form.offsetHeight > 0;
    });
    var form = forms[0];
    var sticky = root.querySelector('.vcv2__sticky');
    if (!form || !sticky) return false;

    root.dataset.formLinksReady = 'true';
    root.querySelectorAll('[data-vcv2-form-link], .vcv2__sticky').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        form.scrollIntoView({ behavior: 'auto', block: 'center' });
        updateSticky();
      });
    });

    function updateSticky() {
      sticky.classList.toggle('is-visible', form.getBoundingClientRect().bottom < 0);
    }
    updateSticky();
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    window.setInterval(updateSticky, 500);
    return true;
  }

  function start() {
    var attempts = 0;
    function tryInit() {
      attempts += 1;
      if (!initVitaminaCFormLinks() && attempts < 20) window.setTimeout(tryInit, 250);
    }
    tryInit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
